import appApi from "@/app/api";
import { PAYMENT_V2_ENDPOINT_V1 } from "@/components/Pricing/v2/constants.pricing";

const APIURL = `${PAYMENT_V2_ENDPOINT_V1}/subscription/pause`;

type PausePlanSubscriptionResponse = {
  success: boolean;
  message: string;
  resume_timestamp: number;
};

export const handlePausePlanSubscription = async (
  month: number,
  token?: string,
): Promise<PausePlanSubscriptionResponse> => {
  try {
    const res = await appApi.post(
      APIURL,
      {
        month_pause: month,
      },
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      },
    );

    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
